import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import backgroundImg from './img/background.png'
import mobile_border from './img/mobile-border.png'
import mobile_tapes from './img/mobile-tapes.png'
import desktop_border from './img/desktop-border.png'
import desktop_tapes from './img/desktop-tapes.png'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSingleName, weddingDate },
  buttonMessage,
  warningMessage,
  locale = 'pt-BR',
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const date = new Intl.DateTimeFormat(locale)
    .format(new Date(weddingDate.timestamp))
    .replace(/\//g, ' . ')

  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro280">
      <div className="intro280mobile screen">
        <div className="main-background-5RLgyK"></div>
        <div className="intro-content">
          <div className="photodate-5RLgyK">
            <img className="border-aKhxgN" src={mobile_border} />
            <img
              className="a-photo169-aKhxgN"
              src={background || backgroundImg}
            />
            <img className="tapes-aKhxgN" src={mobile_tapes} />
            <div className="date-aKhxgN">{date}</div>
          </div>

          <div className="couple-name-5RLgyK notranslate">
            <h1 className="couple-single-namegr-cgYX9T authentic-signature-normal-mine-shaft-48px bp1-intro280-animate-enter">
              {coupleSingleName.groom}
            </h1>
            <div className="couple-single-namebr-cgYX9T authentic-signature-normal-mine-shaft-48px bp1-intro280-animate-enter1">
              {coupleSingleName.bride}
            </div>
          </div>
        </div>

        <div className="container-center-horizontal">
          <div className="button-5RLgyK">
            <p
              className="site-de-casamento-e-EzWGIP"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <button className="button-EzWGIP" onClick={onSkipIntro}>
              <div className="pular-introduo-JKhT5H">{buttonMessage}</div>
            </button>
          </div>
        </div>
      </div>

      <div className="intro280desktop screen">
        <div className="main-background-NJjCEu"></div>
        <div className="container-center-horizontal">
          <div className="button-NJjCEu">
            <p
              className="site-de-casamento-e-G7xEJY"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <button className="button-G7xEJY" onClick={onSkipIntro}>
              <div className="pular-introduo-Nj8VWW">{buttonMessage}</div>
            </button>
          </div>
        </div>

        <div className="intro-content">
          <div className="couple-name-NJjCEu notranslate">
            <div className="couple-single-namegr-eydRul authentic-signature-normal-mine-shaft-48px bp2-intro280-animate-enter">
              {coupleSingleName.groom}
            </div>
            <div className="couple-single-namebr-eydRul authentic-signature-normal-mine-shaft-48px bp2-intro280-animate-enter1">
              {coupleSingleName.bride}
            </div>
          </div>

          <div className="photodate-NJjCEu">
            <img className="border-rvSIdL" src={desktop_border} />
            <img
              className="a-photo169-rvSIdL"
              src={background || backgroundImg}
            />
            <img className="tapes-rvSIdL" src={desktop_tapes} />
            <div className="date-rvSIdL">{date}</div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
